<template>
  <section class="sec_footer-support">
    <div class="home-title-area">
      <p class="home-title">お買い物サポート</p>
    </div>

    <div class="guide-box">
      <div class="guide-heading">
        <div class="guide-heading_icon">
          <img src="/image/img_guide001.png" alt="" />
        </div>
        <h2 class="guide-heading_text">Shopping Guide</h2>
      </div>

      <div class="guide-list guide-list_3col">
        <div v-for="item in PRIMARY_ITEMS" :key="item.image" class="guide-item">
          <div class="guide-item_icon" :class="item.iconModifier">
            <img :src="item.image" alt="" />
          </div>
          <p class="guide-item_title" v-html="item.title"></p>
          <p class="guide-item_text" v-html="item.text"></p>
          <NuxtLink :to="item.to" class="guide-item_link">
            {{ item.linkLabel }}<span class="guide-item_arrow"></span>
          </NuxtLink>
        </div>
      </div>

      <div class="guide-list guide-list_2col">
        <div v-for="item in SECONDARY_ITEMS" :key="item.image" class="guide-item">
          <div class="guide-item_icon" :class="item.iconModifier">
            <img :src="item.image" alt="" />
          </div>
          <p class="guide-item_title" v-html="item.title"></p>
          <p class="guide-item_text" v-html="item.text"></p>
          <NuxtLink :to="item.to" class="guide-item_link">
            {{ item.linkLabel }}<span class="guide-item_arrow"></span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sec_footer-support`（お買い物サポート）。
 * サポート導線4コンテンツの1つ。単体では使わず `OrganismsSupport` から呼ぶ。
 * 文言・改行位置は支給デザインどおり。現行も静的に持っている種類の値なのでここに置く（決定#5）。
 * `v-html` はここで定義した定数リテラルのみを描画する（外部入力は通さない）。
 */
type GuideItem = {
  image: string;
  iconModifier?: string;
  title: string;
  text: string;
  to: string;
  linkLabel: string;
};

const PRIMARY_ITEMS: ReadonlyArray<GuideItem> = [
  {
    image: '/image/img_guide002.png',
    title: '5,000円（税込）以上の<br />お買い物で送料無料',
    text: 'ご注文受付後、通常3〜5日程度で<br />お届けします。',
    to: '/guide#guide-delivery',
    linkLabel: '配送・送料について',
  },
  {
    image: '/image/img_guide003.png',
    iconModifier: 'icon003',
    title: '代金引換・クレジット払い・<br />後払いOK',
    text: 'ご注文内容によって、ご利用可能な<br />お支払い方法が異なる場合がございます。',
    to: '/guide#guide-payment',
    linkLabel: 'お支払いについて',
  },
  {
    image: '/image/img_guide004.png',
    title: '未開封品に限り、商品到着後<br />8日以内なら返品可能',
    text: 'フリーダイヤルまたはお問い合わせ<br />フォームからご連絡ください。',
    to: '/guide#guide-return',
    linkLabel: '返品・交換について',
  },
] as const;

const SECONDARY_ITEMS: ReadonlyArray<GuideItem> = [
  {
    image: '/image/img_guide005.png',
    title: 'ご購入時の会員登録で<br />お買い物が快適に',
    text: 'はじめてご注文いただく場合は、<br class="sp-only" />会員登録（無料）が必要です。<br class="pc-only" />ご登録後は<br class="sp-only" />マイページがご利用いただけます。',
    to: '/register',
    linkLabel: '新規会員登録',
  },
  {
    image: '/image/img_guide006.png',
    iconModifier: 'icon006',
    title: 'お買い物で迷った時の<br />「よくあるご質問」はこちら',
    text: 'お客さまから寄せられる、よくある<br class="sp-only" />ご質問をまとめました。<br class="pc-only" />ご不明な点が<br class="sp-only" />ございましたら、まずはご確認ください。',
    to: '/faq',
    linkLabel: 'よくあるご質問',
  },
] as const;
</script>
